import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !request.url.includes('/api/logins')) {
          this.handleUnauthorized();
        } else if (error.status === 500) {
          this.handleServerError(error);
        }
        return throwError(error);
      })
    );
  }

  private handleUnauthorized() {
    Swal({
      title: 'Sua sessão atual é inválida',
      text: 'Por favor, refaça seu login.',
      icon: 'error',
      closeOnClickOutside: false,
      closeOnEsc: false,
    }).then(() => {
      localStorage.clear();
      this.router.navigate(['/login']).then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 100);
      });
    });
  }

  private handleServerError(error: HttpErrorResponse) {
    const errorMessage = this.extractErrorMessage(error);

    Swal({
      title: 'Erro',
      text: errorMessage || 'Ocorreu um erro interno. Tente novamente mais tarde.',
      icon: 'error',
      closeOnClickOutside: false,
      closeOnEsc: false,
    });
  }

  private extractErrorMessage(error: HttpErrorResponse): string {
    if (error.error?.Mensagem) {
      return error.error.Mensagem;
    }

    if (error.error?.error) {
      return error.error.error;
    }

    if (typeof error.error === 'string') {
      return error.error;
    }

    return 'Erro interno do servidor';
  }
}
